/* eslint-disable import/no-unresolved */

// The rule above to shut ESLint from complaining
// about unresolved Swiper's CSS imports
// Why? see: https://github.com/import-js/eslint-plugin-import/issues/2266

import { useRef } from 'react';

import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType, Navigation } from 'swiper';

import { VehicleImageViewModel } from '@api/index';
import { FALLBACK_IMAGE_URL } from '@constants/constants';
import { Image } from '@shared';

import {
  CarCarouselDotsWrapper,
  CarCarouselItem,
  CarCarouselWrapper,
} from '../CarRentalCard.styled';

interface ICarCarousel {
  handleCarouselChange: (index: number) => void;
  vehicles: Array<VehicleImageViewModel>;
  activeIndex: number;
}

const CarCarousel: React.FC<ICarCarousel> = ({
  handleCarouselChange,
  vehicles,
  activeIndex,
}) => {
  const swiperRef = useRef<SwiperType>();

  return (
    <CarCarouselWrapper>
      {vehicles.length > 1 ? (
        <CarCarouselDotsWrapper>
          <Button
            shape='circle'
            icon={<LeftOutlined />}
            disabled={activeIndex === 0}
            onClick={() => swiperRef.current?.slidePrev()}
          />
          <Button
            shape='circle'
            icon={<RightOutlined />}
            disabled={activeIndex === vehicles.length - 1}
            onClick={() => swiperRef.current?.slideNext()}
          />
        </CarCarouselDotsWrapper>
      ) : null}
      <Swiper
        onRealIndexChange={(swiper) => handleCarouselChange(swiper.realIndex)}
        modules={[Navigation]}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
        speed={600}
      >
        {vehicles.map((vehicle, i) => (
          <SwiperSlide key={i}>
            <CarCarouselItem>
              <Image
                src={vehicle?.image ?? FALLBACK_IMAGE_URL}
                alt={vehicle?.name || ''}
                height={179}
                width={450}
              />
            </CarCarouselItem>
          </SwiperSlide>
        ))}
      </Swiper>
    </CarCarouselWrapper>
  );
};

export default CarCarousel;
